import React from 'react';
import { createRoot } from 'react-dom/client';
import classnames from 'classnames';
import { get, isEqual } from 'lodash';

function CustomOverlay(map, config) {
	this.config = config;
	this.setMap(map);
}

export default function CreateCustomOverlay(google, map, config) {
	CustomOverlay.prototype = new google.maps.OverlayView();

	CustomOverlay.prototype.remove = function remove() {
		if (this.div) {
			if (this.root) {
				this.root.unmount();
				this.root = null;
			}
			this.div.remove();
			this.div = null;
			this.setMap(null);
		}
	};

	// NOTE: Always provide labelText for reliable change detection. The label
	// fallback uses isEqual on React elements, which fails for inline closures.
	CustomOverlay.prototype.update = function update(newConfig) {
		const labelChanged =
			'labelText' in newConfig
				? this.config.labelText !== newConfig.labelText
				: 'label' in newConfig &&
					!isEqual(this.config.label, newConfig.label);
		this.config = { ...this.config, ...newConfig };
		if (this.div) {
			this.div.className = classnames(
				'custom-marker',
				this.config.className,
			);
			if (labelChanged && this.config.label) {
				if (!this.root) {
					this.root = createRoot(this.div);
				}
				this.root.render(<div>{this.config.label}</div>);
			}
		}
	};

	CustomOverlay.prototype.draw = function draw() {
		let { div } = this;

		if (!div) {
			div = document.createElement('div');
			div.className = classnames('custom-marker', this.config.className);

			const panes = this.getPanes();
			panes.overlayImage.appendChild(div);

			if (this.config.label) {
				this.root = createRoot(div);
				this.root.render(<div>{this.config.label}</div>);
			}

			this.div = div;
		}

		const point = this.getProjection().fromLatLngToDivPixel(
			this.config.position,
		);
		div.style.left = `${get(point, 'x', 0)}px`;
		div.style.top = `${get(point, 'y', 0)}px`;
	};

	return new CustomOverlay(map, {
		...config,
		position: new google.maps.LatLng(
			config.location.latitude,
			config.location.longitude,
		),
	});
}
